/* =================================================================
   VALORA PDP — offer tiles + media gallery (Shopify version).
   Cart, reveal, accordion and smooth-scroll live in valora-theme.js.
   ================================================================= */
(function () {
  "use strict";
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- offer tiles: selection drives the buy button ---------- */
  $$("[data-offers]").forEach(function (group) {
    var tiles = $$(".offer-tile", group);
    var section = group.closest("section") || document;
    var buyBtn = $("[data-buy-btn]", section);

    function select(tile) {
      tiles.forEach(function (t) { t.toggleAttribute("data-selected", t === tile); });
      if (!buyBtn) return;
      buyBtn.setAttribute("data-variant-id", tile.getAttribute("data-variant-id"));
      buyBtn.setAttribute("data-qty", tile.getAttribute("data-qty"));
      buyBtn.setAttribute("data-product", tile.getAttribute("data-product"));
      var arrow = $(".btn__arrow", buyBtn);
      buyBtn.textContent = (tile.getAttribute("data-cta") || "Add to cart") + " ";
      if (arrow) buyBtn.appendChild(arrow);
    }

    tiles.forEach(function (tile) {
      tile.setAttribute("tabindex", "0");
      tile.setAttribute("role", "radio");
      tile.addEventListener("click", function () { select(tile); });
      tile.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); select(tile); }
      });
    });
  });

  /* ---------- gallery: swipeable track + synced thumbnails -----------
     Photos (and the video) live in a horizontally-scrolling track with
     CSS scroll-snap, so touch users can swipe between them natively.
     Thumbnails and the prev/next arrows scroll the track to a slide;
     a scroll listener keeps the active thumb (and video playback) in
     sync when the user swipes instead of clicking.
     ------------------------------------------------------------------ */
  (function () {
    var track = $("[data-gallery-track]");
    var thumbsWrap = $("[data-gallery-thumbs]");
    if (!track || !thumbsWrap) return;
    var slides = $$("[data-gallery-slide]", track);
    var thumbs = $$(".gallery__thumb", thumbsWrap);
    var prevBtn = $("[data-gallery-prev]");
    var nextBtn = $("[data-gallery-next]");
    var current = 0;

    function setActive(index) {
      current = index;
      thumbs.forEach(function (t, i) { t.classList.toggle("is-active", i === index); });
      slides.forEach(function (slide, i) {
        var video = $("[data-gallery-video]", slide);
        if (!video) return;
        if (i === index) {
          var p = video.play();
          if (p && p.catch) p.catch(function () { /* user can press play */ });
        } else {
          video.pause();
        }
      });
    }

    function goTo(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      slides[index].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener("click", function () { goTo(i); });
    });
    if (prevBtn) prevBtn.addEventListener("click", function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { goTo(current + 1); });

    var scrollTimer;
    track.addEventListener("scroll", function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        if (index !== current) setActive(index);
      }, 80);
    });
  })();
})();
